exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Slider__show_half .slick-list {\n  padding: 0 20% 0 0 !important;\n}\n\n.slick-list {\n  flex-grow: 1;\n}\n", ""]);

// exports
exports.locals = {
	"show_half": "DS__Slider__show_half"
};